module.exports = __webpack_public_path__ + "img/2_of_Spades.svg.c7e6599c.png";